/**
 * Fiskaly 签名信息表：是否展示 activity_code 可编辑列。
 * @param vatNumberIsPersonal - GET 餐厅详情返回的 vat_number_is_personal
 */
export function shouldShowFiskalyActivityCodeColumn(vatNumberIsPersonal?: boolean): boolean {
    return vatNumberIsPersonal === true;
}

/**
 * 是否至少展示一行签名信息表：已有签名数据，或个人税号需编辑 activity_code。
 * @param hasFiskalyInfo - 是否已有 signer_id / serial_number
 * @param vatNumberIsPersonal - GET 餐厅详情返回的 vat_number_is_personal
 */
export function shouldShowFiskalySignInfoList(
    hasFiskalyInfo: boolean,
    vatNumberIsPersonal?: boolean,
): boolean {
    return hasFiskalyInfo || vatNumberIsPersonal === true;
}
